import { Printer, Receipt } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtTime, brl } from "@/lib/api";
import { billPayload, reprintPayload, orderGroups, comandaTitle } from "@/lib/mobile";
import { btReady, getBt, printDoc, printErr } from "@/lib/btprint";
import { useAuth } from "@/context/AuthContext";

const row = "flex w-full items-center gap-3 rounded-xl border border-slate-200 px-3 py-3 text-left text-sm transition-colors hover:bg-[#e3f2fd]";

export function ReprintDialog({ open, c, onClose }) {
  const { session } = useAuth();
  const bt = getBt(session.user.id);
  const send = async (kind, title, payload) => {
    try {
      await printDoc(session, kind, title, payload);
      onClose();
    } catch (e) { toast.error(printErr(e)); }
  };
  const groups = orderGroups(c).filter((g) => g.order);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-sm overflow-y-auto" data-testid="m-reprint-dialog">
        <DialogHeader><DialogTitle>Reimprimir</DialogTitle><DialogDescription>{btReady(bt) ? "A conta sai na impressora Bluetooth. Os pedidos saem no computador do caixa." : "A impressão sai no computador do caixa."}</DialogDescription></DialogHeader>
        <div className="space-y-2">
          <button className={row} onClick={() => send("bill", `Conta · ${comandaTitle(c)}`, billPayload(c))} data-testid="m-reprint-bill">
            <Receipt className="h-5 w-5 text-[#1565c0]" /><span className="flex-1 font-semibold">Conta parcial (conferência)</span><span className="font-mono">{brl(c.total)}</span>
          </button>
          {groups.map((g) => (
            <button key={g.order.id} className={row} onClick={() => send("order", `2ª via · Pedido ${g.order.number} · ${comandaTitle(c)}`, reprintPayload(c, g.order, g.items))} data-testid={`m-reprint-order-${g.order.number}`}>
              <Printer className="h-5 w-5 text-[#1565c0]" /><span className="flex-1">Pedido {g.order.number} · {fmtTime(g.order.at)}<span className="block text-xs text-slate-500">{g.items.length} item(ns) · {g.order.user}</span></span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
